import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/** A next-activity reminder to show on the game's own HUD, since the page's DOM is hidden behind the game. */
export interface GameHudReminder {
  id: string
  message: string
}

interface ActivitiesState {
  notifiedActivityIds: string[] // Reminder keys already shown (activityId@minutesBeforeStart)
  testNotificationTrigger: number // Timestamp to trigger test notification
  gameHudReminder: GameHudReminder | null
}

const initialState: ActivitiesState = {
  notifiedActivityIds: [],
  testNotificationTrigger: 0,
  gameHudReminder: null
}

const activitiesSlice = createSlice({
  name: 'activities',
  initialState,
  reducers: {
    markActivityNotified: (state, action: PayloadAction<string>) => {
      if (!state.notifiedActivityIds.includes(action.payload)) {
        state.notifiedActivityIds.push(action.payload)
      }
    },
    clearNotifiedActivities: (state) => {
      state.notifiedActivityIds = []
    },
    resetActivities: (state) => {
      state.notifiedActivityIds = []
      state.gameHudReminder = null
    },
    triggerTestNotification: (state) => {
      // Use timestamp to trigger test notification
      state.testNotificationTrigger = Date.now()
    },
    showGameHudReminder: (state, action: PayloadAction<GameHudReminder>) => {
      state.gameHudReminder = action.payload
    },
    clearGameHudReminder: (state) => {
      state.gameHudReminder = null
    }
  }
})

export const {
  markActivityNotified,
  clearNotifiedActivities,
  resetActivities,
  triggerTestNotification,
  showGameHudReminder,
  clearGameHudReminder
} = activitiesSlice.actions

export default activitiesSlice.reducer
